// extracted by mini-css-extract-plugin
export default {"searchIcon":"FilteringInputField_searchIcon__+0D+F"};